export const MINIMUM_TRANSACTIONS_SHOWN = 4;
export const MINIMUM_PAYMENTS_SHOWN = 10;

export const TRANSITION_DURATION = 300;
